import AppService from 'App/legacy/AppService';
import { hasSoftDeployAccess } from 'App/services/FeatureHelperStandalone';

/**
 * Client-card twin of contactCardNavigation. Every in-app link to a client card
 * goes through these two helpers, which is what makes the REACT_CLIENT_CARD
 * cutover a single decision.
 *
 * Only the flag is read here, not `shouldUseAngularPage` — a link never carries
 * a page, so the only question is which card, and the card resolves its own
 * landing page once it is open.
 */
const hasReactCard = () => hasSoftDeployAccess('REACT_CLIENT_CARD');

export const goToClientCard = (clientId: number) => {
	if (hasReactCard()) {
		Tools.$state.go('react-root-clientCard', { id: clientId });
		return;
	}
	Tools.$state.go('account.dashboard', { id: clientId });
};

/**
 * `activityId` makes the card expand that activity in its timeline. It is a
 * declared query param on the angular card (`account.dashboard`, url
 * `?activityId`) but NOT on the react route, which declares no queryParams — so
 * ui-router drops it there. Passing it is therefore a no-op with the flag on,
 * until `/accounts/:id/:page?` declares it and ClientCard reads it (WEB-9633).
 */
export const getClientCardHref = (clientId: number, activityId?: number) => {
	if (hasReactCard()) {
		// The react-root state has no customerId in its url — react-router runs on
		// the hash below it, so the card's route is just /accounts/:id/:page?.
		return Tools.$state.href('react-root-clientCard', { id: clientId, ...(activityId ? { activityId } : {}) });
	}
	return Tools.$state.href('account.dashboard', {
		customerId: AppService.getCustomerId(),
		id: clientId,
		...(activityId ? { activityId } : {})
	});
};
